import React from 'react'
import { SiteProvider } from './src/common/Context/app'
import "./src/common/styles/app.css";
import "animate.css"
import { AppListProvider } from './src/common/Context/AppListContext';
import { IPlatformProvider } from './src/common/Context/IPlatformContext';
import { ToastProvider } from './src/common/Context/ToastContext';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'

// reCAPTCHA v3 site key (public). Its matching SECRET lives only on the server
// in deploy/mailer/.env. Override per environment with GATSBY_RECAPTCHA_SITE_KEY.
const RECAPTCHA_SITE_KEY = process.env.GATSBY_RECAPTCHA_SITE_KEY || '6LdqG-otAAAAAOd-BbnKM5574ddjV4f-23J5en12'

export const wrapRootElement = ({ element }) => (
  <SiteProvider>
    <ToastProvider>
    <IPlatformProvider>
      <AppListProvider>
        <GoogleReCaptchaProvider reCaptchaKey={RECAPTCHA_SITE_KEY}>
          {element}
        </GoogleReCaptchaProvider>
      </AppListProvider>
    </IPlatformProvider>
    </ToastProvider>
  </SiteProvider>
)